import { createRoot } from 'react-dom/client';
import AccountProvider from "./Account/AccountProvider";

const root = createRoot(document.getElementById('Main'));
root.render(<AccountProvider/>);

String.prototype.shorten = function (left, right) {
    if (!right) right = left;
    if (this.length <= left + right) return this;
    return this.substring(0, left) + "..." + this.substring(this.length - right);
};

window.objMap = (obj, func) => {
    return Object.entries(obj).map(([k, v]) => func(v, k));
}

Object.defineProperty(String.prototype, 'capitalize', {
	value: function () {
		return this.charAt(0).toUpperCase() + this.slice(1);
	},
	enumerable: false
});